// extracted by mini-css-extract-plugin
module.exports = {"controls":"controls--O+s5+"};